import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function Step3({ onClose }) {
  return (
    <>
      <IconButton onClick={onClose} size="small" style={{ position: "absolute", top: 8, right: 8 }}>
        <CloseIcon />
      </IconButton>
      <Box mb={2}>
        <Typography fontWeight={500} fontSize={20}>
          Find and Replace
        </Typography>
      </Box>
      <Box mt={5} display="flex" flexDirection="column" alignItems="center">
        <CheckCircleIcon sx={{ fontSize: 48, color: "success.main", mb: 5 }} />
        <Typography variant="body1" paragraph>
          Successfully updated
        </Typography>
      </Box>
    </>
  );
}
